export default (snapshot, fieldnames) => {
  return fieldnames.some(name=>!snapshot[name]);
}
